<template>
	<div class="spinner">
		<span v-for="index in 12" :key="index" class="spinner__bar" />
	</div>
</template>

<style lang="scss">
@import '@/components/_shared/Spinner/Spinner';
</style>
